import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Footer({ children, className, as, ...rest }) {
    const Component = as ?? "footer";
    return (_jsx(Component, { className: classNames("cvr-footer", className), ...rest, children: children }));
}
